/*
 * On smaller devices, display a '...' button which opens a menu with the Actions
 * as menu options. On larger devices, display the Actions as a list of icons.
 *
 * The Actions are to be placed in the default slot.
 */
<template>
  <v-container>
    <v-row v-if="useMenu()">
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
        </template>
        <v-list>
          <slot></slot>
        </v-list>
      </v-menu>
    </v-row>
    <v-row v-if="!useMenu()">
      <slot></slot>
    </v-row>
  </v-container>
</template>

<script>
import Component from 'vue-class-component';
import ActionBase from './ActionBase.vue';

@Component
export default class ActionMenu extends ActionBase {
}
</script>
